import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { initBehaviorTracking } from "./utils/analytics";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import PhilosophySection from "./components/PhilosophySection";
import LaalIshqVideo from "./components/LaalIshqVideo";
import WhatWeDoSection from "./components/WhatWeDoSection";
import CafeChokChokVideo from "./components/CafeChokChokVideo";
import PortfolioSection from "./components/PortfolioSection";
import ProcessSection from "./components/ProcessSection";
import NriSection from "./components/NriSection";
import AboutSection from "./components/AboutSection";
import TestimonialsSection from "./components/TestimonialsSection";
import AboutCinCinSection from "./components/AboutCinCinSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";
import WhatsAppFloat from "./components/WhatsAppFloat";
import FaqPage from "./components/FaqPage";
import CorporateEventsPage from "./components/CorporateEventsPage";
import PrivateEventsPage from "./components/PrivateEventsPage";

function HomePage() {
  useEffect(() => { initBehaviorTracking(); }, []);
  return (
    <>
      <Navigation />
      <HeroSection />
      <PhilosophySection />
      <LaalIshqVideo />
      <WhatWeDoSection />
      <CafeChokChokVideo />
      <PortfolioSection />
      <ProcessSection />
      <NriSection />
      <AboutSection />
      <TestimonialsSection />
      <AboutCinCinSection />
      <ContactSection />
      <FooterSection />
      <WhatsAppFloat />
    </>
  );
}

function App() {
  return (
    <div data-testid="cincin-app" className="min-h-screen bg-[#EFEAE6]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/corporate" element={<CorporateEventsPage />} />
          <Route path="/private" element={<PrivateEventsPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
